import type { HTMLAttributes } from 'react'
import { cn } from '../cn'
import { IconClose } from '../Icons'
import type { UseCollectionResult } from './useCollection'

export interface FilterChipsProps<RowT> extends HTMLAttributes<HTMLDivElement> {
  collection: UseCollectionResult<RowT>
  stableChipNames?: boolean
}

export function FilterChips<RowT>({ collection, stableChipNames = false, className = '', ...props }: FilterChipsProps<RowT>) {
  if (collection.activeFilters.length === 0) return null

  return (
    <div className={cn('flex flex-wrap items-center gap-2', className)} aria-label="Active filters" {...props}>
      {collection.activeFilters.map((filter) => (
        <span
          key={filter.id}
          className="inline-flex min-h-8 items-center gap-2 rounded-pill bg-stone px-3 text-xs font-medium text-ink-secondary"
        >
          {filter.label}
          <button
            type="button"
            onClick={() => collection.clearFilter(filter.id)}
            aria-label={`Remove ${filter.label}`}
            data-exact-set-name={stableChipNames ? `Remove ${filter.name} filter` : undefined}
            className="inline-flex size-5 items-center justify-center rounded-full text-ink-muted hover:bg-line focus-visible:outline-none focus-visible:shadow-focus coarse:min-h-tap coarse:min-w-tap coarse:-my-2"
          >
            <IconClose size={12} />
          </button>
        </span>
      ))}
      <button
        type="button"
        onClick={collection.clearFilters}
        className="min-h-8 rounded-pill px-3 text-xs font-medium text-link hover:text-link-hover focus-visible:outline-none focus-visible:shadow-focus"
      >
        Clear
      </button>
    </div>
  )
}
